import React, { Component, ErrorInfo, ReactNode } from 'react';
import { USER_ERROR } from './api-calls';
import { Button } from './components/atoms';
import StyledSpan from './styled/typography/StyledSpan';
import { getUserOS, getDeviceType, getUserBrowserName } from './utils/getBowserData';
import { withTranslation, WithTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const os =  getUserOS();
    const device =  getDeviceType();
    const url  = window.location.href;
    const browser = getUserBrowserName();
    await USER_ERROR({
      error: error.message,
      errorInfo: errorInfo.componentStack,
      os,
      device,
      url,
      browser,
    });
    // console.error('Uncaught error:', error, errorInfo);
  }
  public clearCache() {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
      window.location.href = '/app';
    }
  }

  public render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <div
          style={{
            background: 'rgb(20, 23, 28)',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <StyledSpan>
            {t("errorBoundary")}
          </StyledSpan>
          <Button
            primary
            text={t("return")}
            onClick={this.clearCache}
            color="white"
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
